import { defineMessages } from 'react-intl';

export default defineMessages({
  urlLostInfo: {
    id: 'urlLostInfo',
    defaultMessage: '资源标识符缺少相关信息',
  },
  merchant: {
    id: 'merchant',
    defaultMessage: '商户',
  },
  allDay: {
    id: 'allDay',
    defaultMessage: '全天',
  },
  vipPrice: {
    id: 'vipPrice',
    defaultMessage: '会员价',
  },
  vip: {
    id: 'vip',
    defaultMessage: '会员',
  },
  notVip: {
    id: 'notVip',
    defaultMessage: '非会员',
  },
  noBenefit: {
    id: 'noBenefit',
    defaultMessage: '不享受优惠',
  },
  notHaveBenefit: {
    id: 'notHaveBenefit',
    defaultMessage: '享受折扣菜品优惠',
  },
  fullMoneyRule: {
    id: 'fullMoneyRule',
    defaultMessage: ' 满{symbol}{dishNum}{ruleName}',
  },
  fullDishNumRuleEvery: {
    id: 'fullDishNumRuleEvery',
    defaultMessage: '{symbol}每',
  },
  fullDishNumRule: {
    id: 'fullDishNumRule',
    defaultMessage: '{symbol}满{dishNum}份{ruleName}',
  },
  perOrderLimitNum: {
    id: 'perOrderLimitNum',
    defaultMessage: '{symbol}每单限{dishNum}份',
  },
  limitedVIP: {
    id: 'limitedVIP',
    defaultMessage: '仅限会员{symbol}',
  },
  limitedNotVIP: {
    id: 'limitedNotVIP',
    defaultMessage: '仅限非会员{symbol}',
  },
  allGoods: {
    id: 'allGoods',
    defaultMessage: '全部商品',
  },
  someGoods: {
    id: 'someGoods',
    defaultMessage: '部分商品',
  },
  conditionEnable: {
    id: 'conditionEnable',
    defaultMessage: '{condition}可用',
  },
  onLimitMax: {
    id: 'tooltip.onLimitMax',
    defaultMessage: '已达到添加上限',
  },
  historySearch: {
    id: 'search.historySearch',
    defaultMessage: '历史搜索',
  },
  clearSearch: {
    id: 'search.clearSearch',
    defaultMessage: '清空记录',
  },
  noSearchData: {
    id: 'search.noSearchData',
    defaultMessage: '哎呀  没有相关搜索结果',
  },
  searchPlacehodler: {
    id: 'search.searchPlacehodler',
    defaultMessage: '搜索店内商品',
  },
  noSearchResult: {
    id: 'search.noSearchResult',
    defaultMessage: '没有搜索结果',
  },
  discount: {
    id: 'coupon.discount',
    defaultMessage: '折',
  },
  getCoupon: {
    id: 'coupon.getCoupon',
    defaultMessage: '领券',
  },
  haveFinished: {
    id: 'coupon.haveFinished',
    defaultMessage: '已领完',
  },
  viewPackage: {
    id: 'coupon.viewPackage',
    defaultMessage: '查看礼包',
  },
  storePackage: {
    id: 'coupon.storePackage',
    defaultMessage: '进店礼包',
  },
  validOnTheDay: {
    id: 'coupon.validOnTheDay',
    defaultMessage: '当日有效',
  },
  validityPeriod: {
    id: 'coupon.validityPeriod',
    defaultMessage: '有效期',
  },
  receiveSuccess: {
    id: 'coupon.receiveSuccess',
    defaultMessage: '领取成功',
  },
  fullValueCanUse: {
    id: 'coupon.fullValueCanUse',
    defaultMessage: '消费满{currency}{fullValue}可用',
  },
  limitValueCanUse: {
    id: 'coupon.limitValueCanUse',
    defaultMessage: '满{currency}{limitValue}可用',
  },
  useUnlimited: {
    id: 'coupon.useUnlimited',
    defaultMessage: '使用无门槛',
  },
  viewCoupon: {
    id: 'coupon.viewCoupon',
    defaultMessage: '查看优惠券',
  },
  pickCoupon: {
    id: 'coupon.pickCoupon',
    defaultMessage: '立刻领取',
  },
  viewAndPickCoupon: {
    id: 'coupon.viewAndPickCoupon',
    defaultMessage: '查看领券',
  },
  viewReceivedCoupon: {
    id: 'coupon.viewReceivedCoupon',
    defaultMessage: '查看已领券',
  },
  goToLogin: {
    id: 'goToLogin',
    defaultMessage: '去登录',
  },
  goToLoginDesc: {
    id: 'goToLoginDesc',
    defaultMessage: '尚未登录，登录后立享会员权益！',
  },
  mustPayWithRestoreDesc: {
    id: 'mustPayWithRestoreDesc',
    defaultMessage: '您已选择会员价，只能使用储值支付',
  },
  isCancelDishCoupon: {
    id: 'isCancelDishCoupon',
    defaultMessage: '当前选择优惠与商品优惠不能通用，是否取消商品优惠，选择优惠券',
  },
  canUseCoupon: {
    id: 'canUseCoupon',
    defaultMessage: '可用优惠券',
  },
  notCanUseCoupon: {
    id: 'notCanUseCoupon',
    defaultMessage: '不可用优惠券',
  },
  canUseDiscount: {
    id: 'canUseDiscount',
    defaultMessage: '可用卡',
  },
  notCanUseDiscount: {
    id: 'notCanUseDiscount',
    defaultMessage: '不可用卡',
  },
  paid: {
    id: 'paid',
    defaultMessage: '已支付',
  },
  discounted: {
    id: 'discounted',
    defaultMessage: '已优惠',
  },
  invoiceTitle: {
    id: 'invoiceTitle',
    defaultMessage: '发票抬头',
  },
  taxpayerId: {
    id: 'taxpayerId',
    defaultMessage: '纳税人识别号',
  },
  optional: {
    id: 'optional',
    defaultMessage: '选填',
  },
  view: {
    id: 'view',
    defaultMessage: '查看',
  },
  allProducts: {
    id: 'allProducts',
    defaultMessage: '所有商品',
  },
  someProducts: {
    id: 'someProducts',
    defaultMessage: '部分商品',
  },
  someProductsNotHave: {
    id: 'someProductsNotHave',
    defaultMessage: '部分商品不',
  },
  friendlyReminder: {
    id: 'friendlyReminder',
    defaultMessage: '友情提示',
  },
  inputIndividualOrCompanyTitle: {
    id: 'placeholder.inputIndividualOrCompanyTitle',
    defaultMessage: '请输入个人或公司抬头',
  },
  inputTaxpayerId: {
    id: 'placeholder.inputTaxpayerId',
    defaultMessage: '请输入纳税人识别号',
  },
  inputNote: {
    id: 'placeholder.inputNote',
    defaultMessage: '输入备注',
  },
  mealOrder: {
    id: 'title.mealOrder',
    defaultMessage: '堂食点餐',
  },
  search: {
    id: 'title.search',
    defaultMessage: '搜索',
  },
  shopLogo: {
    id: 'alt.shopLogo',
    defaultMessage: '门店logo',
  },
  shopSwitch: {
    id: 'alt.shopSwitch',
    defaultMessage: '门店切换',
  },
  shopIcon: {
    id: 'alt.shopIcon',
    defaultMessage: '门店icon',
  },
  goToOrder: {
    id: 'goToOrder',
    defaultMessage: '继续点餐',
  },
  person: {
    id: 'person',
    defaultMessage: '人',
  },
  defaultSort: {
    id: 'defaultSort',
    defaultMessage: '默认分类',
  },
  monday: {
    id: 'monday',
    defaultMessage: '周一',
  },
  tuesday: {
    id: 'tuesday',
    defaultMessage: '周二',
  },
  wednesday: {
    id: 'wednesday',
    defaultMessage: '周三',
  },
  thursday: {
    id: 'thursday',
    defaultMessage: '周四',
  },
  friday: {
    id: 'friday',
    defaultMessage: '周五',
  },
  saturday: {
    id: 'saturday',
    defaultMessage: '周六',
  },
  sunday: {
    id: 'sunday',
    defaultMessage: '周天',
  },
  weekday: {
    id: 'weekday',
    defaultMessage: '工作日',
  },
  weekend: {
    id: 'weekend',
    defaultMessage: '周末',
  },
  to: {
    id: 'to',
    defaultMessage: '到',
  },
  back: {
    id: 'back',
    defaultMessage: '返回',
  },
  languageSwitch: {
    id: 'languageSwitch',
    defaultMessage: '切换语言',
  },
  microMart: {
    id: 'microMart',
    defaultMessage: '微商城',
  },
  onlyLeft: {
    id: 'onlyLeft',
    defaultMessage: '仅剩',
  },
  required: {
    id: 'required',
    defaultMessage: '必填',
  },
  couponExpirydate: {
    id: 'couponExpirydate',
    defaultMessage: '自领取{validDayNum}天内有效，当天不可用',
  },
  noAvailableCards: {
    id: 'noAvailableCards',
    defaultMessage: '暂无可用卡哦~',
  },
  enjoyDiscounts: {
    id: 'enjoyDiscounts',
    defaultMessage: '即刻购买可享整单最高<span>{discount}</span>折优惠',
  },
  unavailableCards: {
    id: 'unavailableCards',
    defaultMessage: '暂无不可用卡哦~',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/global/index.js